export default __webpack_public_path__ + "static/media/challenge-list-header-bg.e0d6eed2.png";